module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard', {
    on: {
      "onAddPanel": _vm.addPanel,
      "onShowPanel": _vm.handleTogglePanelVisibilityByType,
      "onInstantPoll": _vm.handleShowInstantPollDialog
    }
  }, [_c('div', {
    attrs: {
      "slot": "panels"
    },
    slot: "panels"
  }, [_c('draggable', _vm._b({
    ref: "message_panels",
    staticClass: "message-panels",
    on: {
      "start": _vm.dragStarted,
      "end": _vm.dragEnded
    },
    model: {
      value: (_vm.panelsList),
      callback: function($$v) {
        _vm.panelsList = $$v
      },
      expression: "panelsList"
    }
  }, 'draggable', _vm.draggableOptions, false), _vm._l((_vm.panelsList), function(el) {
    return _c('panel', {
      key: el.id
    }, [(_vm.isMessagePanel(el.id)) ? _c('message-panel', {
      key: el.id,
      attrs: {
        "id": el.id,
        "title": el.title,
        "type": _vm.panelTypes[el.id],
        "interactions": _vm.interactions(el.id),
        "onAirUsers": _vm.companyUsers,
        "loading": _vm.loadingInteractions[el.id],
        "loadingSuccess": _vm.loadingInteractionsSuccess[el.id],
        "color": _vm.panelSettings[el.id].colour,
        "columns": _vm.panelSettings[el.id].columns ? _vm.panelSettings[el.id].columns.toString() : null,
        "goToLastScrollPosition": _vm.goToLastScrollPosition,
        "isPaused": !!_vm.panelPaused[el.id],
        "hasMoreInteractions": _vm.panelHasMoreInteractions(el.id),
        "twitterTrends": _vm.twitterTrends,
        "pollStats": _vm.pollStats(el.id),
        "campaigns": _vm.campaigns,
        "channels": _vm.channels,
        "settings": _vm.panelSettings[el.id],
        "canClose": !['activity'].includes(_vm.panelTypes[el.id]),
        "mediaPreload": _vm.panelSettings[el.id].mediaPreload,
        "panelLock": _vm.panelSettings[el.id].panelLock
      },
      on: {
        "closePanel": function($event) {
          return _vm.closePanel(el.id)
        },
        "loadMore": function($event) {
          return _vm.loadMore(el.id)
        },
        "showSettings": function($event) {
          return _vm.showSettings(el.id)
        },
        "pausePanel": function($event) {
          return _vm.pausePanel(el.id)
        },
        "unpausePanel": function($event) {
          return _vm.unpausePanel(el.id)
        },
        "resetPanel": function($event) {
          return _vm.resetPanel(el.id)
        },
        "searchPanel": _vm.searchPanelInteractions,
        "removeOnAir": _vm.removeOnAir,
        "onOpenProfile": _vm.handleOpenProfile
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isChatPanel(el.id)) ? _c('chat', {
      on: {
        "closePanel": function($event) {
          return _vm.closePanel(el.id)
        }
      }
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "gallery"
    },
    slot: "gallery"
  }, [_c('gallery', {
    attrs: {
      "visible": _vm.galleryVisible,
      "images": _vm.galleryImages,
      "selectedIndex": _vm.galleryIndex
    },
    on: {
      "setVisible": _vm.setGalleryVisible
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "settings"
    },
    slot: "settings"
  }, [(_vm.panelSettingsDialog.id) ? _c('message-panel-settings', {
    attrs: {
      "visible": _vm.panelSettingsDialogVisible,
      "id": _vm.panelSettingsDialog.id,
      "name": _vm.panelSettingsDialog.name,
      "color": _vm.panelSettingsDialog.color,
      "columns": _vm.panelSettingsDialog.columns,
      "channelIds": _vm.panelSettingsDialog.channelIds,
      "campaignIds": _vm.panelSettingsDialog.campaignIds,
      "channels": _vm.channels,
      "panelType": _vm.panelSettingsDialog.type,
      "mediaPreload": _vm.panelSettingsDialog.mediaPreload,
      "panelLock": _vm.panelSettingsDialog.panelLock,
      "campaigns": _vm.activeCampaigns
    },
    on: {
      "setVisible": _vm.setPanelSettingsVisible,
      "saveSettings": _vm.savePanelSettings
    }
  }) : _vm._e(), _vm._v(" "), _c('instant-poll', {
    attrs: {
      "channels": _vm.channels,
      "visible": _vm.instantPollDialogVisible
    },
    on: {
      "close": _vm.handleCloseInstantPoll,
      "cancel": _vm.handleCloseInstantPoll,
      "createPanel": _vm.handleCreatePanel
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.profileDialogVisible && _vm.selectedProfile) ? _c('profile-detail-dialog', {
    attrs: {
      "originalProfile": _vm.selectedProfile,
      "updatedProfileMap": _vm.updatedProfileMap,
      "profileId": _vm.getProfileId(_vm.selectedProfile),
      "profileDialogVisible": _vm.profileDialogVisible
    },
    on: {
      "onDialogVisibilityChange": _vm.handleProfileDialogVisibilityChanged,
      "profileUpdated": _vm.handleProfileUpdated
    }
  }) : _vm._e(), _vm._v(" "), _c('thread-dialog')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676600b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/interaction/DashboardContainer.vue
// module id = 3316
// module chunks = 3